import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, image, url }) => {
    const siteName = "Vision Sports Academy";
    const fullTitle = `${title} | ${siteName}`;
    const defaultDescription = "Vision Sports Academy - Developing Zimbabwe's Next Generation of Champions through elite sports training and education.";
    const defaultKeywords = "sports academy, Zimbabwe, Harare, training, youth development, champions";
    const siteUrl = "https://visionsportszim.com";

    return (
        <Helmet>
            {/* Standard Metadata */}
            <title>{fullTitle}</title>
            <meta name="description" content={description || defaultDescription} />
            <meta name="keywords" content={keywords || defaultKeywords} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={url || siteUrl} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description || defaultDescription} />
            <meta property="og:image" content={image || "/vision logo.jpeg"} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={url || siteUrl} />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description || defaultDescription} />
            <meta name="twitter:image" content={image || "/vision logo.jpeg"} />
        </Helmet>
    );
};

export default SEO;
